// extracted by mini-css-extract-plugin
export var active = "howItWorks-module--active--dea68";
export var bullet = "howItWorks-module--bullet--514a7";
export var button = "howItWorks-module--button--d55a6";
export var container = "howItWorks-module--container--523e6";
export var contentCell = "howItWorks-module--contentCell--ad3ca";
export var contentCellEmpty = "howItWorks-module--contentCellEmpty--23026";
export var contentDesktop = "howItWorks-module--contentDesktop--1981f";
export var contentHeader = "howItWorks-module--contentHeader--dbf15";
export var contentMobile = "howItWorks-module--contentMobile--4496e";
export var desc = "howItWorks-module--desc--7e3c6";
export var header = "howItWorks-module--header--8796c";
export var highlightSecond = "howItWorks-module--highlightSecond--096d0";
export var image = "howItWorks-module--image--68c66";
export var imagePart = "howItWorks-module--imagePart--7708a";
export var lottieWrap = "howItWorks-module--lottieWrap--9b7f2";
export var lottieWrapSpan = "howItWorks-module--lottieWrapSpan--15c85";
export var mobileStep = "howItWorks-module--mobileStep--414b0";
export var mobileSteps = "howItWorks-module--mobileSteps--97b8d";
export var scrollArea = "howItWorks-module--scrollArea--d1946";
export var section = "howItWorks-module--section--7cc0e";
export var slide = "howItWorks-module--slide--12b5c";
export var stickyInner = "howItWorks-module--stickyInner--320c7";
export var stickyWrapper = "howItWorks-module--stickyWrapper--c8c70";
export var stickyWrapperStatic = "howItWorks-module--stickyWrapperStatic--175e3";
export var subtitle = "howItWorks-module--subtitle--1de12";
export var tab = "howItWorks-module--tab--f7d37";
export var tabs = "howItWorks-module--tabs--7207e";
export var tabsWrapper = "howItWorks-module--tabsWrapper--28b06";
export var text = "howItWorks-module--text--4a7ab";
export var textPart = "howItWorks-module--textPart--0e70f";
export var title = "howItWorks-module--title--8bf52";
export var titleDesktop = "howItWorks-module--titleDesktop--6fceb";
export var titleMobile = "howItWorks-module--titleMobile--9f08b";